import { render } from "./ClientAddView.vue?vue&type=template&id=0c38d82d"
import script from "./ClientAddView.vue?vue&type=script&lang=js"
export * from "./ClientAddView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__